<div class="wrap" *ngIf="qcState">
	<div class="card-button-group">
		<!-- <button class="button-general" (click)="runQc()">QC</button> -->
		<button class="button-general" (click)="clickApply()">
			<!-- <div class="same-line">
				<i class="glyphicons glyphicons-filter"></i> -->
				<div>Set</div>
			<!-- </div> -->
		</button>
	</div>
	<div class="filter-options">
		<div class="qc-filter-title">
			<div class="qc-filter-title-text">
				<label>QC Filter - {{qcState.name}}</label>
			</div>
			<div class="filter-check-all">
				<i *ngIf="false&&showCheckAllBox" class="glyphicons" [ngClass]="{'glyphicons-filter-applied': !isCheckAll, 'glyphicons-filter-remove': isCheckAll}" [title]="isCheckAll ? 'Uncheck All':'Check All'"  (click)="toggleCheckAll()"></i>
			</div>
		</div>
	
		<div class="filter-level-1" > <!-- [ngClass]="{'disable-section': !isQc}" -->
			<div>
				<div *ngFor="let option of filterOptions; let idx2 = index;" 
					class="filter-option-item" 
					[title]="option.descriptionLong"
					(mouseover)="onMouseoverCode(option)"
					(mouseout)="onMouseoutCode()">
					<div class="option-checkbox">
						<div style="padding:3px 0px 0px;">
							<input *ngIf="qcState.num>1.51" type="checkbox" name="option-{{idx2}}"
								[(ngModel)]="option.isSelected"
								[disabled]="!option.count"
								(ngModelChange)="toggleFilterOption(option, true)"
							>
						</div>
					</div>
					<div *ngIf="selectedLayer&&selectedLayer.category.code===addressCateCode" class="option-legend">
						<div *ngIf="option.value==='FS1'||option.value==='FS1L'" class="legend-circle legend-circle-small">
							<div class="legend-black"></div>
						</div>
						<div *ngIf="option.value==='FS2'||option.value==='FS2L'" class="legend-circle legend-circle-small">
							<div class="legend-red"></div>
						</div>
						<div *ngIf="option.value==='FS3'||option.value==='FS3L'" class="legend-circle legend-circle-large">
							<div class="legend-black"></div>
						</div>
						<div *ngIf="option.value==='FS4'||option.value==='FS4L'" class="legend-circle legend-circle-large">
							<div class="legend-red"></div>
						</div>
						<div *ngIf="option.value==='FS5'||option.value==='FS5L'" class="legend-diamond legend-diamond-large">
							<div class="legend-red"></div>
						</div>
						<div *ngIf="option.value==='FS6'||option.value==='FS6L'" class="legend-diamond legend-diamond-large">
							<div class="legend-red"></div>
						</div>
						<div *ngIf="option.value==='FS7'||option.value==='FS7L'" class="legend-diamond legend-diamond-small">
							<div class="legend-red"></div>
						</div>
						<div *ngIf="option.value==='FS8'||option.value==='FS8L'" class="legend-diamond legend-diamond-small">
							<div class="legend-red"></div>
						</div>
						<div *ngIf="option.value==='FS9'||option.value==='FS9L'" class="legend-triangle legend-triangle-large">
							<div></div>
						</div>
						<div *ngIf="option.value==='FSA'" class="legend-line-thin">
							<div class="legend-red"></div>
						</div>
						<div *ngIf="option.value==='FSB'" class="legend-line-thin">
							<div class="legend-red"></div>
						</div>
					</div>
					<label class="option-label" [title]="option.descriptionLong"><span [ngClass]="{'item-with-tooltip': option.descriptionLong}">{{option.value}}</span>{{' - ' + option.name}}</label>
					<div class="option-count">{{option.count ? option.count : ''}}</div>
				</div>
			</div>
		</div>
	</div>
	
	<div *ngIf="showFishboneFilter&&false" class="fishbone-filters">
		<app-qc-filters-interlayers></app-qc-filters-interlayers>
	</div>

	<div class="attribute-filters">
		<app-feat-attribute-filters-popup></app-feat-attribute-filters-popup>
	</div>
</div>

